import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "78bf1e0e-68f0-423c-9547-441a9a071ce7"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooter78bf1e0e68f0423c9547441a9a071ce7(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const Logo = AppStore.presets["Logo"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooter78bf1e0e68f0423c9547441a9a071ce7 footer`}>
      {props["links"] || <Navigation className="Links26121d2c04704efcBcfc8f5652367088" parentTag={buildClassName("Links26121d2c04704efcBcfc8f5652367088", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="Logo034e7713Dd5b47dbA647689fd47ea512" parentTag={buildClassName("Logo034e7713Dd5b47dbA647689fd47ea512", parentTag)} contentSlug="footer-logo" logoType="FOOTER" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="CopyrightF947f772988c46148ff0Dafedf5a85d5" parentTag={buildClassName("CopyrightF947f772988c46148ff0Dafedf5a85d5", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="Groupflow4a2c3ad762544e85B7fd522c2a61a4b1" parentTag={buildClassName("Groupflow4a2c3ad762544e85B7fd522c2a61a4b1", parentTag)} {...props} />}
    </footer>
  );
}

// id: "4a2c3ad7-6254-4e85-b7fd-522c2a61a4b1"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "78bf1e0e-68f0-423c-9547-441a9a071ce7"
export function Groupflow4a2c3ad762544e85B7fd522c2a61a4b1(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="Groupflow4a2c3ad762544e85B7fd522c2a61a4b1" parentTag={buildClassName("Groupflow4a2c3ad762544e85B7fd522c2a61a4b1", parentTag)} {...props} />
  );
}

// id: "f947f772-988c-4614-8ff0-dafedf5a85d5"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "78bf1e0e-68f0-423c-9547-441a9a071ce7"
export function CopyrightF947f772988c46148ff0Dafedf5a85d5(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="CopyrightF947f772988c46148ff0Dafedf5a85d5" parentTag={buildClassName("CopyrightF947f772988c46148ff0Dafedf5a85d5", parentTag)} {...props} />
  );
}

// id: "26121d2c-0470-4efc-bcfc-8f5652367088"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "78bf1e0e-68f0-423c-9547-441a9a071ce7"
export function Links26121d2c04704efcBcfc8f5652367088(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="Links26121d2c04704efcBcfc8f5652367088" parentTag={buildClassName("Links26121d2c04704efcBcfc8f5652367088", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "034e7713-dd5b-47db-a647-689fd47ea512"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "78bf1e0e-68f0-423c-9547-441a9a071ce7"
export function Logo034e7713Dd5b47dbA647689fd47ea512(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo034e7713Dd5b47dbA647689fd47ea512" parentTag={buildClassName("Logo034e7713Dd5b47dbA647689fd47ea512", parentTag)} contentSlug="footer-logo" logoType="FOOTER" {...props} />
  );
}

// id: "f58ab239-45e0-4a92-8537-135f08dd8509"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "26121d2c-0470-4efc-bcfc-8f5652367088"
export const NavMenuSlugF58ab23945e04a928537135f08dd8509 = "footer-nav";

// id: "0cb4e50d-0b08-4611-ac4d-e356cff6acc8"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "034e7713-dd5b-47db-a647-689fd47ea512"
export const ContentSlug0cb4e50d0b084611Ac4dE356cff6acc8 = "footer-logo";

// id: "5d63d6b7-4fca-474e-8ce9-f683988f89b9"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "034e7713-dd5b-47db-a647-689fd47ea512"
export const LogoType5d63d6b74fca474e8ce9F683988f89b9 = "FOOTER";

const Components = {
  DefaultFooter78bf1e0e68f0423c9547441a9a071ce7,
  Groupflow4a2c3ad762544e85B7fd522c2a61a4b1,
  CopyrightF947f772988c46148ff0Dafedf5a85d5,
  Links26121d2c04704efcBcfc8f5652367088,
  Logo034e7713Dd5b47dbA647689fd47ea512,
  NavMenuSlugF58ab23945e04a928537135f08dd8509,
  ContentSlug0cb4e50d0b084611Ac4dE356cff6acc8,
  LogoType5d63d6b74fca474e8ce9F683988f89b9
}

export default Components;